import axios from 'axios'
import { API_BASE } from './api_base'
import * as Auth from './auth'

const axiosBase = axios.create({
  baseURL: API_BASE
});
const token = Auth.getToken();

const configAuthentication = async configure => {

  if (token) {
    configure.headers.Authorization = `Bearer ${token}`
  }

  return configure
}

const checkTokenExpired = error => {
  if (error.response.status === 401 && token) {
    Auth.signout()
  }

  return Promise.reject(error);
}

axiosBase.interceptors.request.use(configAuthentication)

axiosBase.interceptors.response.use(null, checkTokenExpired)

export default axiosBase;